/****************************************************
 * Module Name:  offerStone.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { useState } from "react";
import { DataGridPro, GridToolbarExport, GridToolbar, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, TextField, Tooltip } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { ThemeProvider, createTheme, Stack, } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import StoneDetailModal from "../common/stoneDetailModal";
import Utility from "../../utility/utility";
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { LoadingButton } from "@mui/lab";
import NoPermission from "../common/noPermission";
import OfferProxy from "../../utility/proxy/manager/offerProxy";
import renderCellExpand from "../common/dataGridCellExpand";
import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import PacketHistoryModal from "../common/packetHistoryModal";
import StoneMediaModal from "../common/stoneMediaModal";
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";
import PageTitle from "../common/pageTitle";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.tableLayouts = {
  Mylayout: {
    fillColor: function (rowIndex) {
      return rowIndex % 2 === 0 ? "#CCCCCC" : null;
    },
  },
};


const OfferStone = () => {
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("");
  // const [customerData, setCustomerData] = useState({
  //   customer: [],
  //   customerOptions: [],
  // });
  const [listData, setListData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [offerLoader, setOfferLoader] = useState(false);
  const [access] = useState(false);
  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [multipleStones, setMultipleStones] = useState([]);

  const [outetColumnNames, setOuterColumnNames] = React.useState([]);
  const [stoneMediaURL, setStoneMediaURL] = useState([]);
  const [showStoneMediaModal, setShowStoneMediaModal] = useState(false);
  const [showPacketDetailModal, setShowPacketDetailModal] = useState(false);
  const [showKapanDetailModal, setShowKapanDetailModal] = useState(false);
  const [packetId, setPacketId] = useState("");
  const [kapanId, setKapanId] = useState("");

  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.OPERATION_OFFER
    )
  );

  useEffect(() => {
    PageTitle("OPERATION_OFFER_STONEWISE");
    handleSearch();
  }, []);


  const handleSearch = () => {
    let stoneIds = [];
    setOfferLoader(true);
    if (multipleStones.length > 0) {
      multipleStones.split(",").forEach(stoneid => {
        stoneIds.push(Number(stoneid));
      });
    }

    OfferProxy.GetOfferDataByStone(stoneIds,
      local_Permission.length > 0 ? -1 : Constants.loggedInUser.id,
      Constants.loggedInUser.usertype, (response) => {
        if (response) {
          response = response.sort((a, b) => a.offerCustomerDetailsList.length < b.offerCustomerDetailsList.length);
          setListData(response);
          handleArray(response);
          setOfferLoader(false);
          prepareColumns();
        } else {
          setOfferLoader(false);
          setShowSuccessSnackbar(true);
          setSuccessMessage(Constants.APiFailErrorMessage);
          setSnackbarVariant("error");
        }
      });
  };

  const handleArray = (lListData) => {
    let newMainData = {};
    if (lListData.length > 0) {
      lListData.map((list) => {
        let offerStones = []
        list.offerCustomerDetailsList.map((stone) =>
          offerStones.push({
            offerID: stone.offerid,
            stoneid: stone.stoneid,
            stoneprice: stone.stoneprice,
            originaldiscount: stone.originaldiscount,
            offerdiscount: stone.offerdiscount,
            originalprice: stone.originalprice,
            offerprice: stone.offerppc,
            originaltotal: stone.originaltotal,
            offertotal: stone.offertotal,
            customername: stone.customername,
            customercompanyname: stone.customercompanyname,
            customerid: stone.customerid,
            employeename: stone.employeename,
            brokerid: stone.brokerid,
            brokername: stone.brokername,
            brokercompanyname: stone.brokercompanyname,
            employeeid: stone.employeeid,
            createdat: stone.createdat,
            remark: stone.remark,
            offerrapnetprice: stone.offerrapnetprice,
            rapnetprice: stone.rapnetprice,
          })
        );
        newMainData[list.stoneid] = offerStones;
        return true;
      });
    }
    setMainData(newMainData);
  };

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const handleClose = () => {
    setShowStoneDetailModal(false);
    setShowSuccessSnackbar(false);
    setShowPacketDetailModal(false);
    setShowStoneMediaModal(false);
  };


  const prepareColumns = () => {
    let columnNames = [];

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        columnNames.push(columnData);
        if (columnData.field === "stoneid") {
          columnNames.push(
            {
              headerName: "NO OF OFFER",
              field: "offerCustomerDetailsList",
              align: "center",
              headerAlign: "center",
              type: "number",
              valueFormatter: (params) => params.value,
              renderCell: (params) => params.row.offerCustomerDetailsList.length,
            }
          )
        }
      }
    });
    setOuterColumnNames(columnNames);
  }

  const handlePacketDetailModal = (params, kapanid) => {
    setPacketId(params);
    setKapanId(kapanid);
    setShowPacketDetailModal(true);
  };

  const columnName = [
    {
      field: "offerID",
      headerName: "OFFER ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
    },
    {
      field: "customername",
      headerName: "CUSTOMER COMPANY",
      headerAlign: "center",
      align: "center",
      width: 160,
      renderCell: (params) => params.row.customerid + " | " + params.row.customercompanyname,
    },
    {
      field: "brokername",
      headerName: "BROKER COMPANY",
      headerAlign: "center",
      align: "center",
      width: 160,
      renderCell: (params) => (params.row.brokerid === -1) ? "-" : params.row.brokerid + " | " + params.row.brokercompanyname,
    },
    {
      field: "employeename",
      headerName: "CREATED BY",
      headerAlign: "center",
      align: "center",
      width: 160,
      renderCell: (params) => params.row.employeeid + " | " + params.row.employeename,
    },
    {
      field: "createdat",
      headerName: "DATE",
      headerAlign: "center",
      align: "center",
      width: 85,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.createdat)

    },
    {
      field: "rapnetprice",
      headerName: "ORIGINAL RAP",
      headerAlign: "center",
      align: "center",
      width: 115,
      type: "number",
      valueFormatter: (params) => params.value,
      cellClassName: (params) => 'lavenderCell',
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
    },
    {
      field: "offerrapnetprice",
      headerName: "OFFER RAP",
      headerAlign: "center",
      align: "center",
      width: 115,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.offerrapnetprice)
    },
    {
      field: "originaldiscount",
      headerName: "ORIGINAL DIS",
      headerAlign: "center",
      align: "center",
      width: 110,
      type: "number",
      valueFormatter: (params) => params.value,
      cellClassName: (params) => 'lavenderCell',
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.originaldiscount)
    },
    {
      field: "offerdiscount",
      headerName: "OFFER DIS",
      headerAlign: "center",
      align: "center",
      width: 115,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.offerdiscount)
    },
    {
      field: "originalprice",
      headerName: "ORIGINAL P/CT",
      headerAlign: "center",
      align: "center",
      width: 115,
      type: "number",
      valueFormatter: (params) => params.value,
      cellClassName: (params) => 'lavenderCell',
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.originalprice)
    },
    {
      field: "offerprice",
      headerName: "OFFER P/CT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 110,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.offerprice)
    },
    {
      field: "originaltotal",
      headerName: "ORIGINAL TOTAL",
      headerAlign: "center",
      align: "center",
      width: 115,
      type: "number",
      valueFormatter: (params) => params.value,
      cellClassName: (params) => 'lavenderCell',
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.originaltotal)
    },
    {
      field: "offertotal",
      headerName: "OFFER TOTAL",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 115,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.offertotal)
    },
    {
      field: "remark",
      headerName: "REMARK",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
  ];

  //external fields
  const columnsData = {
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      headerAlign: "center",
      width: 80,
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    "e24542ae-7b98-44f2-82be-09dfa2dd850b": {
      field: "mumid",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      width: 90,
      renderCell: (params) => (!params.value) ? "" : params.value,
    },
    "7a913460-41e0-441d-85b9-1f33d71416fb": {
      field: "suratid",
      headerName: "REF NO",
      headerAlign: "center",
      align: "center",
      width: 90,
      renderCell: (params) => (!params.value) ? "" : params.value,
    },
    "9dfe5dd6-726c-465b-9f61-22fca6660b4f": {
      field: "kapanid",
      headerName: "KAPANID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black',
          }}
          onClick={() => {
            setKapanId(params.row.kapanid);
            setShowKapanDetailModal(true);
          }}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
      width: 80,
    },
    "8a492e00-6167-45de-b078-e572e47c8a39": {
      field: "packetid",
      headerName: "PACKETID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      renderCell: (params) => {
        if (params.value === null || params.row.kapanid === null) {
          return;
        } else {
          return Utility.NeedToShowPacketDetailModal() ? (
            <Button
              sx={{ textDecorationLine: "underline", color: "black" }}
              onClick={() => handlePacketDetailModal(params.value, params.row.kapanid)}
            >
              {params.value}
            </Button>
          ) : (
            <div>{params.value}</div>
          );
        }
      }
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COL",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 60,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 75,
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 60,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 60,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 60,
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 60,
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "rapnetprice",
      headerName: "RAP",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DISC",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount)
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 100,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      width: 60,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 140,
      renderCell: renderCellExpand,
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "f97a0118-3891-4f77-abf7-8636c26d594c": {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "01e90aca-bdcb-4e8e-80ec-2d7007df8cd3": {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      width: 170,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
      field: "height",
      headerName: "HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
      field: "width",
      headerName: "WIDTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      editable: true,
      renderCell: renderCellExpand,
    },
    "77e48fa7-d118-4ab8-865b-9b85b32a004f": {
      field: "fancycolor1",
      headerName: "F.COLOR",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "6defca68-d5d9-4c30-ae83-938a01f45a07": {
      field: "colortype",
      headerName: "COLOR TYPE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "ccba9873-174e-4060-963a-9893c3625bb2": {
      field: "fancycolorovertone",
      headerName: "OVERTONE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "c9aa6ee7-30e3-423e-a534-80bb5ef7bbaf": {
      field: "fancycolorintensity",
      headerName: "F.COL.INTENSITY",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "e7210f4a-6e0a-4591-8428-e6845004ed04": {
      field: "crownheight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
      field: "culetsize",
      headerName: "CULET SZ",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "e3f77521-2c57-46bc-a02b-3c884685d2be": {
      field: "culetcondition",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "e83c2978-9088-49f0-9dc1-bcced73025fd": {
      field: "gridlemin",
      headerName: "GIRDLEMIN",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
      field: "intensitylongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "06d2a589-0d42-4dde-8724-acf2448c839a": {
      field: "laserinscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "dd934505-1865-48cb-878f-f5d3c18af2d5": {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "e9028170-e978-4978-a2c9-1889c1821495": {
      field: "gridlecondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
      field: "gridlepercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
      field: "pavilionangle",
      headerName: "PV.ANGLE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "24ba0bf8-4ca1-4726-ad90-19a62c8c72e6": {
      field: "boxid",
      headerName: "BOXID",
      headerAlign: "center",
      width: 60,
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "cf694b75-ba5d-4a73-8fcf-e7566974c4b6": {
      field: "media",
      headerName: "MEDIA",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: (params) => (
        <Tooltip title={"Stone Media"} sx={{ cursor: "pointer" }}>
          <VideoLibraryTwoToneIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setStoneMediaURL(params.row.stonemediaurl);
              setShowStoneMediaModal(true);
            }} />
        </Tooltip>
      ),
    },
    "f3223657-c8d2-449c-b2f5-5a54c78401ce": {
      field: "tableinc",
      headerName: "TABLE INC",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "f114ad2c-8560-4da7-9b03-03ba6bfe39a5": {
      field: "sideinc",
      headerName: "SIDE INC",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "e993a4f7-7c50-4d83-abae-fccc03382742": {
      field: "h_and_a",
      headerName: "H&A",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "f2fe7666-6489-40ce-b4b7-040c68c88bf3": {
      field: "eyeclean",
      headerName: "EYE CLEAN",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "b38b9fdf-bfb8-43c6-82a2-1e366fa71523": {
      field: "tinge",
      headerName: "TINGE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.tinge.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "c95089ee-166d-4783-817c-2638f6d40df1": {
      field: "milky",
      headerName: "MILKY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.milky.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "2a6475ff-481f-48c6-9e92-3ede0b97d7c0": {
      field: "luster",
      headerName: "LUSTER",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "556ae429-3605-4df4-88d8-b5223fc2e2fb": {
      field: "tableblack",
      headerName: "TABLE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "5c70d1ca-2a7b-4660-8160-0beff7ad1150": {
      field: "sideblack",
      headerName: "SIDE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "a1299782-d545-4d70-bcbc-7d576e396d64": {
      field: "length",
      headerName: "LENGTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "dfd5488a-b600-4e75-9735-98c26f78dc84": {
      field: "strln",
      headerName: "STAR LENGTH",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "66dfbc62-477f-42f0-8097-56c5d8329156": {
      field: "lrhalf",
      headerName: "LR HALF",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "e683145c-29dd-4d41-af1a-518ff80090d2": {
      field: "keytosymbols",
      headerName: "KEY TO SYMBOLS",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "e32fe363-07cc-4307-82d2-82ae1069b5be": {
      field: "age",
      headerName: "AGE",
      headerAlign: "center",
      align: "center",
      width: 60,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertDateToAge(params.row.age),
    }
  };

  const getDetailPanelHeight = React.useCallback(() => 'auto', []);

  const getDetailPanelContent = React.useCallback(
    (row, mainData) => <DetailPanelContent row={row} mainData={mainData} />,
    [],
  );

  function DetailPanelContent({ row: rowProp, mainData }) {
    let row = mainData[rowProp.stoneid];
    return (
      <Stack
        sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
        direction="column"
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            width: "90vw",
            position: "relative",
            "& .MuiTablePagination-selectLabel": {
              marginTop: "15px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "15px",
            },
            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontWeight: Constants.defaultFontWeight,
            },
            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
              color: "#1976d2",
              padding: "4px 5px",
              borderRadius: "4px",
            },
            "& .css-cc8tf1": {
              fontWeight: Constants.defaultFontWeight,
            },
            height: 'auto',
            marginLeft: '16px',
          }}
        >
          <DataGridPro
            disableRowSelectionOnClick={false}
            density="compact"
            columns={columns}
            rows={row}
            getRowId={(row) => row.offerID}
            sx={{
              '& .MuiDataGrid-columnHeader': {
                color: '#fff',
                backgroundColor: 'grey',
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "8px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "15px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "22px",
              },

              fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              maxHeight: '30vh',
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            initialState={{
              pagination: {
                paginationModel: Constants.pageSize,
              },
            }}
            pageSizeOptions={Constants.pageSizeOptions}
            pagination
          />
        </Box>
      </Stack>
    );
  }

  const columns = columnName;

  const materialColumns = outetColumnNames;

  const defaultMaterialTheme = createTheme();

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          alignItems: "center",
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
        <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
        {offerLoader ? (
          <CircularProgress size="1rem" />
        ) : (
          <Tooltip title="Reload List">
            <RefreshOutlinedIcon
              onClick={() => handleSearch()}
              color="primary"
              fontSize="medium"
              sx={{ cursor: "pointer", mt: 1 }}
            />
          </Tooltip>
        )}
        <GridToolbarQuickFilter debounceMs={500} />
      </GridToolbarContainer>
    )
  }
  return (
    <div>
      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneId}
          handleClose={handleClose}
        />
      ) : null}

      {showKapanDetailModal ? (
        <KapanHistoryModal
          show={showKapanDetailModal}
          kapanId={kapanId}
          close={() => setShowKapanDetailModal(false)}
        />
      ) : null}
      {showSuccessSnackbar ? (
        <CommonSnackbar
          show={true}
          message={successMessage}
          variant={snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          title={snackbarVariant === "success" ? "Success" : "Failed"}
          handleClose={handleClose}
        />
      ) : null}

      {showStoneMediaModal ? (
        <>
          <StoneMediaModal
            show={showStoneMediaModal}
            stoneMediaURL={stoneMediaURL}
            handleClose={handleClose}
          />
        </>
      ) : null}

      {showPacketDetailModal ? (
        <>
          <PacketHistoryModal
            show={showPacketDetailModal}
            packetId={packetId}
            kapanId={kapanId}
            close={handleClose}
          />
        </>
      ) : null}

      {
        access ? <NoPermission /> : (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                marginBottom: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  gap: "15px",
                  width: "100%",
                  flexWrap: "wrap",
                }}
              >
                {/* TextField */}
                <TextField
                  placeholder="Enter Multiple Stone Ids"
                  onChange={(e) => setMultipleStones(e.target.value)}
                  multiline
                  rows={1}
                  margin="normal"
                  sx={{
                    width: { xs: "100%", sm: "30rem" },
                    "& .MuiOutlinedInput-root": {
                      padding: "9px 14px !important",
                    },
                  }}
                />

                {/* Search Button */}
                <LoadingButton
                  variant="contained"
                  onClick={() => handleSearch()}
                  startIcon={<SearchOutlinedIcon size="large" />}
                  loading={offerLoader}
                  loadingPosition="start"
                  sx={{
                    height: "40px",
                    minWidth: "120px",
                    whiteSpace: "nowrap",
                    alignSelf: { xs: "stretch", sm: "auto" },
                    marginTop: "8px",
                  }}
                >
                  Search
                </LoadingButton>
              </Box>
            </Box>


            <ThemeProvider theme={defaultMaterialTheme}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  color: '#000',
                  width: "100%",
                  position: "relative",
                  "& .MuiTablePagination-selectLabel": {
                    marginTop: "15px",
                  },
                  "& .MuiTablePagination-displayedRows": {
                    marginTop: "15px",
                  },
                  "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                    fontWeight: Constants.defaultFontWeight,
                  },
                  "& .css-cc8tf1": {
                    fontWeight: Constants.defaultFontWeight,
                  },
                  "& .lavenderCell": {
                    color: "#080808",
                    backgroundColor: "#D8BFD8",
                  },
                  height: "75vh",
                }}
              >
                <DataGridPro
                  disableRowSelectionOnClick={false}
                  density="compact"
                  columns={materialColumns}
                  rows={listData}
                  loading={offerLoader}
                  sx={{
                    '& .MuiDataGrid-columnHeader': {
                      color: '#fff',
                      backgroundColor: 'grey',
                    },
                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                      py: "4px",
                    },
                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                      py: "12px",
                    },
                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                      py: "18px",
                    },

                    '& .MuiDataGrid-row': {
                      whiteSpace: 'nowrap',
                    },
                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                  }}
                  slots={{ toolbar: CustomToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { debounceMs: 500 },
                    },
                  }}
                  getRowId={(row) => row.stoneid}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        // Hide columns id, the other columns will remain visible
                        locationid: false,
                        kapanid: false,
                        country: false,
                        quality: false,
                        shade: false,
                        repacode: false,
                        createdat: false,
                        height: false,
                        width: false,
                        packetid: false,
                        crownheight: false,
                        culetsize: false,
                        culetcondition: false,
                        gridlemin: false,
                        intensitylongtitle: false,
                        laserinscription: false,
                        note: false,
                        paviliondepth: false,
                        gridlecondition: false,
                        gridlepercent: false,
                        pavilionangle: false,
                        white: false,
                        status: false,
                      },
                    },
                    pagination: {
                      paginationModel: Constants.pageSize,
                    },
                  }}
                  pageSizeOptions={Constants.pageSizeOptions}
                  pagination
                  getDetailPanelHeight={getDetailPanelHeight}
                  getDetailPanelContent={({ row }) => getDetailPanelContent(row, mainData)}
                />
              </Box>
            </ThemeProvider>
          </>
        )
      }
    </div>
  );
};

export default OfferStone;
